import { React } from 'react';
import '../../styles/components/hero-items/hero-main.scss'
import { motion } from 'framer-motion';

const HeroMain = () => (
    <div className="hero-main">
        <img src="./img/home/NISAClassicV1_logo_small.png" alt="vol-2-logo" className="vol-logo"/>
        <div className="hero-body">
            <motion.h1 className="hero-text"
                initial={{opacity: 0, translateX: -100}}
                animate={{ opacity: 1, translateX: 0}}
                transition={{duration: .5, delay: 1}}
            >CONSOLE CLASSICS</motion.h1>
            <motion.h1 className="hero-text"
            initial={{opacity: 0, translateX: 100}}
            animate={{ opacity: 1, translateX: 0}}
            transition={{duration: .5, delay: 2}}
            >MAKIN' A COMEBACK,</motion.h1>
            <motion.h1 className="hero-text"
            initial={{opacity: 0, translateX: -100}}
            animate={{ opacity: 1, translateX: 0}}
            transition={{duration: .5, delay: 3}}
            >DOOD!</motion.h1>
        </div>
    </div>
)

export default HeroMain;